import classNames from "classnames";
import * as React from "react";

// components
import { Add } from "@clockwise/design-system/icons";
import { LogoHorizontal } from "../../components/logo";
import { AsanaLogo } from "../asana-logo";

// styles

export interface AclackaProps {
  className?: string;
}

export const Aclacka = ({ className }: AclackaProps) => {
  return (
    <div className={classNames("cw-flex cw-items-center cw-max-w-[480px]", className)}>
      <LogoHorizontal className="cw-w-1/2" />
      <Add className="cw-pr-1 cw-pl-2 cw-text-[38px] cw-fill-accent" />
      <AsanaLogo className="cw-w-[37%] cw-mt-1" />
    </div>
  );
};
